import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyA0BSrwXFoBeMvdN4efvfJqHRQarNbZap4",
    authDomain: "ecohomely-app.firebaseapp.com",
    projectId: "ecohomely-app",
    storageBucket: "ecohomely-app.firebasestorage.app",
    messagingSenderId: "820094665311",
    appId: "1:820094665311:web:51105fe59b5fc6a40211ea",
    measurementId: "G-4LNYHCBKVK"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const db = getFirestore(app);

export { storage, db };
export default storage;